import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TitleTypography = styled(Typography)(() => ({
  fontFamily: 'rem',
}));
